import { env } from '@/env/env';

export default {
    stripePublishableKey: env(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, null),
    // stripeAccount: env(process.env.VUE_APP_STRIPE_ACCOUNT)
};
